export default __webpack_public_path__ + "static/polychain-monsters-e9529036d6fac701ed7366401feafd1b.png";